import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Card, Empty } from '@lithos';

// @tecton

type BoundarySize = 's' | 'm' | 'l';

interface ErrorBoundaryProps {
  children?: ReactNode;
  size?: BoundarySize;
}

interface State {
  hasError: boolean;
}

class ChartErrorBoundary extends Component<ErrorBoundaryProps, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Chart error caught by boundary:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Card title="Error Loading Chart Data">
          <Empty
            placement="embedded"
            title=""
            description="Error loading data"
            actions={undefined}
            useCase={'errorUnknown'}
          />
        </Card>
      );
    }

    return this.props.children;
  }
}

export default ChartErrorBoundary;
